import { Directive, ElementRef, inject } from '@angular/core'

import { DomainService } from '../../../shared/services/domain.service'
import { HelperService } from '../../../shared/services/helper.service'

@Directive({
	selector: '[appHideForDemoAccount]',
})
export class HideForDemoAccountDirective {
	private readonly element = inject(ElementRef)

	constructor(
		private readonly helperService: HelperService,
		private readonly domainService: DomainService,
	) {
		const demoCredential = `demo-${this.domainService.domain.replace('.', '')}`
		if (this.helperService.getUserData()?.user_fields?.NAME === demoCredential) {
			this.element.nativeElement.style.display = 'none'
		}
	}
}
